import { UnifiedWithdrawFormTranslations } from "./unified-withdraw-form-pt-br";

export const UNIFIED_WITHDRAW_FORM_EN_US: UnifiedWithdrawFormTranslations = {
	drawerTitle: "Withdraw & Transfer",
	steps: {
		information: "Information",
		review: "Review",
	},
	totalBalance: "Total Balance",
	sendTo: "Send to",
	sendToPlaceholder: "Type or select an account",
	addNewAccount: "+ Add new account",
	defaultAccountBadge: "Default account",
	liquidValue: "Net Amount",
	liquidValuePlaceholder: "$ 0.00",
	reason: "Request reason",
	reasonPlaceholder: "Enter the withdrawal reason",
	goBack: "Back",
	goForward: "Continue",
	submit: "Request withdrawal",
	errorMessage: "We couldn't process your request. Please try again.",
	successMessage: "Your withdrawal request was submitted successfully!",
	splitBar: {
		available: "Available",
		anticipation: "Anticipation",
	},
	totalChipSuffix: "(total)",
	anticipationFee: "Anticipation fee",
	thirdPartyFee: "Third-party account fee",
	feeError: {
		message: "We couldn't fetch the anticipation fee. Please try again.",
		retry: "Retry",
	},
	review: {
		valuesReview: "Values Review",
		typeLabel: "Type",
		typeWithdraw: "Withdrawal",
		typeWithdrawAndAnticipation: "Withdrawal + Anticipation",
		statusLabel: "Status",
		statusPending: "Processing",
		requestedValue: "Requested amount",
		anticipatedValue: "Anticipated amount",
		thirdPartyFeeLabel: "Third-party account fee",
		anticipationFeeLabel: "Anticipation fee",
		anticipationFeeOnThirdPartyLabel: "Anticipation fee on third-party fee",
		grossValue: "Gross value",
		grossValueAnticipation: "Gross value to anticipate",
		attentionBannerTitle: "Attention",
		attentionBannerMessage:
			"Requests submitted after 10:30 a.m. (Brasília time) will only be processed the following day.",
		bankDataTitle: "Bank details",
		holderLabel: "Account holder",
		accountTypeLabel: "Account type",
		agencyLabel: "Agency",
		accountNumberLabel: "Account number",
		pixKeyLabel: "PIX key",
	},
	completion: {
		title: "All set!",
		description: "The requested amount is being processed by the Finance team.",
	},
	partialFailure: {
		modalTitle: "Withdrawal partially processed",
		modalDescription:
			"The balance withdrawal succeeded, but the anticipation couldn't be completed.",
		title: "Anticipation not completed",
		message:
			"The balance withdrawal succeeded, but the anticipation failed. Please retry only the anticipation.",
		notification:
			"Balance withdrawal succeeded, but the anticipation failed. Please retry only the anticipation.",
	},
};
